module.exports = __webpack_public_path__ + "static/media/parachute2.082d2bef.png";